// lib
import React from 'react'

// components
import PageTitle from 'src/components/header/main/page_title/page_title'

interface IProps {
  name?: string
}

const PageTitleFollowers: React.FC<IProps> = ({ name }) => {
  return (
    <PageTitle
      text={name || ''}
    />
  )
}

export default PageTitleFollowers
